import { render, staticRenderFns } from "./imgTextPush.vue?vue&type=template&id=3e741068&scoped=true"
import script from "./imgTextPush.vue?vue&type=script&lang=js"
export * from "./imgTextPush.vue?vue&type=script&lang=js"
import style0 from "./imgTextPush.vue?vue&type=style&index=0&id=3e741068&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e741068",
  null
  
)

export default component.exports